import { render, staticRenderFns } from "./PanelCompetitionMessagesMail.vue?vue&type=template&id=b6d967d0&scoped=true&"
import script from "./PanelCompetitionMessagesMail.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionMessagesMail.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionMessagesMail.vue?vue&type=style&index=0&id=b6d967d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d967d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d967d0')) {
      api.createRecord('b6d967d0', component.options)
    } else {
      api.reload('b6d967d0', component.options)
    }
    module.hot.accept("./PanelCompetitionMessagesMail.vue?vue&type=template&id=b6d967d0&scoped=true&", function () {
      api.rerender('b6d967d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionMessagesMail.vue"
export default component.exports